"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSharedLinkEventCallbacks = createSharedLinkEventCallbacks;
function createSharedLinkEventCallbacks(contextRef) {
    return {
        community_shared_link_signup_clicked: function (playlistTitle) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_shared_link_signup_clicked', {
                context: 'community',
                playlist_title: playlistTitle,
            });
        },
        community_shared_link_followed: function (playlistTitle) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_shared_link_followed', {
                context: 'community',
                playlist_title: playlistTitle,
            });
        },
        community_shared_link_creator_clicked: function (playlistTitle, creatorDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_shared_link_creator_clicked', __assign({ context: 'community', playlist_title: playlistTitle }, (creatorDisplayName && { creator_display_name: creatorDisplayName })));
        },
    };
}
